<template>
	<div class="input-card-wrapper">
		<div class="input-card-header" :style="hidePadding ? 'margin-bottom: 9px;' : ''">
			<div class="input-card-header-text">{{header}}</div>
			<div class="input-card-header-after">
				<slot name="header-after"/>
			</div>
		</div>
		<div class="input-card" :style="hidePadding ? 'border: 0px; border-radius: 0px;' : ''">
			<div class="input-card-input" :style="hidePadding ? 'padding: 0px;' : ''">
				<slot name="input"/>
			</div>
			<transition name="slideFade">
				<div
					v-if="!hideContent"
					class="input-card-content"
					:style="cardStyle"
					@click="onCardClicked"
				>
					<slot name="content">
						<div class="input-card-content-title-text">{{title}}</div>
						<div class="input-card-content-title-after">
							<slot name="title-after" />
						</div>
						<div class="input-card-content-text">
							<slot name="contentText">{{text}}</slot>
						</div>
					</slot>
				</div>
			</transition>
		</div>
	</div>
</template>

<script>
export default {
	name: 'TInputCard',
	props: {
		header: String,
		title: String,
		text: String,
		hideContent: Boolean,
		hidePadding: Boolean,
		enableCardClick: Boolean,
	},

	computed: {
		cardStyle() {
			return this.enableCardClick ? 'cursor: pointer;' : '';
		}
	},

	methods: {
		onCardClicked() {
			if (this.enableCardClick) this.$emit('click');
		},
	},
};
</script>

<style lang="scss" scoped>
@import '~@/components/evergreen/scss/text';
@import '~@/components/evergreen/scss/colors';

.input-card-wrapper {
	@extend %font-families-ui;
}

.input-card {
	background: #fff;
	border-radius: 5px;
	border: 1px solid get-color($border, 'muted');
	overflow: hidden;
	position: relative;
}

.input-card-header {
	display: grid;
	grid-template-columns: auto minmax(min-content, max-content);
	grid-column-gap: 10px;
	margin-bottom: 10px;
}

.input-card-header-text {
	font-size: 11px;
	font-weight: 600;
	user-select: none;
	margin-left: 2px;
	color: get-color($text, 'dark');
	text-transform: uppercase;
}

.input-card-header-after {
	@extend %text-small;
	margin: 0;
	padding: 0;
	margin-right: 2px;
}

.input-card-input {
	padding: 10px;
	background: white;
	z-index: 3;
}
.input-card-content {
	padding: 10px 10px 10px 20px;
	border-top: 1px solid get-color($border, 'muted');
	background: get-color($background, 'tint1');
	z-index: 1;
	display: grid;
	grid-template-columns: auto minmax(min-content, max-content);
	grid-column-gap: 10px;
}
.input-card-content-title-text {
	@extend %text-default;
	color: get-color($text, 'dark');
	font-weight: 600;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.input-card-content-title-after {
	grid-row: auto / span 2;
}

.input-card-content-text {
	@extend %text-small;
	color: get-color($text, 'muted');
	font-weight: 500;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.slideFade-leave-active,
.slideFade-enter-active {
	transition: .3s;
	opacity: 1;
}
.slideFade-enter, .slideFade-leave-to {
	opacity: 0;
}

</style>

<docs>
```jsx
<t-input-card ref="inputCard" header="Header Text" title="Title text" text="Text text">
	<t-checkbox @click="$refs.inputCard.hideContent = $event.target.checked" slot="header-after" label="Toggle Content" style="margin: 0;"/>
	<t-combobox slot="input" />
	<t-icon-button style="margin-right: 5px;" icon="edit" type="bp" appearance="minimal" size="x-small" slot="title-after" />
</t-input-card>
```
</docs>